<template>
  <div class="container">
    <content-header :data="[{text:'投票活动一览', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
          <router-link to="/vote/new">
            <el-button type="primary" icon="plus">添加</el-button>
          </router-link>
        </div>
        <div class="search-entry">
            <el-input
              placeholder="请输入名称关键字"
              v-model="keywords">
            </el-input>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="id"
            label="投票活动ID"
            width="100"
            fixed>
          </el-table-column>
          <el-table-column
            prop="name"
            label="投票活动名称"
            width="230"
            fixed>
          </el-table-column>
          <el-table-column
            prop="startTime"
            label="开始时间"
            width="100">
          </el-table-column>
          <el-table-column
            prop="endTime"
            label="结束时间"
            width="100">
          </el-table-column>
          <el-table-column
            prop="signupStart"
            label="报名开始时间"
            width="100">
          </el-table-column>
          <el-table-column
            prop="signupEnd"
            label="报名结束时间"
            width="100">
          </el-table-column>
          <el-table-column
            label="封面图">
            <template slot-scope="scope">
             <img style="max-height: 50px;max-width: 130px" :src="scope.row.imageUrl" v-if="scope.row.imageUrl"/>
            </template>
          </el-table-column>
          <el-table-column
            prop="playerCount"
            label="参与人数">
          </el-table-column>
          <el-table-column
            prop="voteCount"
            label="累计投票">
          </el-table-column>
          <el-table-column
            prop="viewCount"
            label="访问量">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="200">
            <template slot-scope="scope">
              <el-button @click="initEditHandle(scope)" type="text" size="small" >编辑</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" >删除</el-button>
              <el-button @click="initPrizeHandle(scope)" type="text" size="small" >奖品</el-button>
              <el-button @click="initPresentHandle(scope)" type="text" size="small" >礼物</el-button>
              <el-button @click="initAdHandle(scope)" type="text" size="small" >广告</el-button>
              <el-button @click="downloadQRHandle(scope)" type="text" size="small" >下载活动小程序码</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > pageSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import VoteModel from 'models/vote'

  export default {
    data () {
      return {
        keywords: '',
        tableData: [],
        curPage: 1,
        pageSize: 10,
        total: 0,
        startDate: '',
        endDate: '',
        dateRange: '',
        datePickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
      }
    },
    created () {
      this.getObjList()
    },
    methods: {
      //
      pageSizeChange (size) {
        this.pageSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.pageSize,
          keywords: this.keywords
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        //
        VoteModel.find(_opts).then(res => {
          this.tableData = res.rows
          this.total = res.total
        })
      },
      //
      deleteHandle (item) {
        this.$confirm('是否确认删除？')
          .then(_ => {
            VoteModel.delete({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      initEditHandle (item) {
        this.$router.push({
          name: 'vote.new',
          query: { id: item.row.id }
        })
      },
      initPrizeHandle (item) {
        this.$router.push({
          name: 'vote.prize.xref',
          query: { id: item.row.id, name: item.row.name }
        })
      },
      initPresentHandle (item) {
        this.$router.push({
          name: 'vote.present.xref',
          query: { id: item.row.id, name: item.row.name }
        })
      },
      initAdHandle (item) {
        this.$router.push({
          name: 'vote.banner.find',
          query: { id: item.row.id, name: item.row.name }
        })
      },
      searchHandle () {
        this.getObjList()
      },
      dateChange (value) {
        if (value) {
          this.startDate = value[0]
          this.endDate = value[1]
        } else {
          this.startDate = ''
          this.endDate = ''
        }
      },
      downloadQRHandle (item) {
        VoteModel.downloadQRCode({
          voteId: item.row.id
        })
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 10px
        margin-bottom: 10px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
      .form-title
        padding-top: 10px
        padding-bottom: 10px
        font-size: 12px
        color: #aaa
      .check-title
        text-align: right
        display: inline-block
        vertical-align: middle
        width: 90px
        font-size: 14px
        color: #48576a
        line-height: 1
        padding: 11px 12px 11px 0
        box-sizing: border-box
      .avatar-uploader
          border: 1px dashed #d9d9d9
          border-radius: 6px
          cursor: pointer
          position: relative
          overflow: hidden
          width: 180px
          &:hover
            border-color: #409EFF
          .avatar-uploader-icon
            font-size: 28px
            color: #8c939d
            width: 178px
            height: 178px
            line-height: 178px
            text-align: center
          .avatar
            width: 178px
            height: 178px
            display: block
</style>



// WEBPACK FOOTER //
// src/views/Vote.vue